import { IPropsInputField } from "./fieldPropertiesInterfaceNew";
import InputField from "./inputFieldNew";

function NumericField({
  model,
  attr,
  value,
  label,
  onChange,
  required,
  autoFocus,
  placeholder
}: IPropsInputField) {
  return (
    <InputField
      type='number'
      attr={attr}
      value={value}
      label={label}
      model={model}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      autoFocus={autoFocus}
    ></InputField>
  );
}

export default NumericField;